<app-service-settings-common
    [defaultData]="store.anamnesisSettings()"
    [title]="'service.settings.anamnesis.header'"
>
    <ng-template #additionalContent>
        <p-divider></p-divider>
        <app-check-input
            id="showHbsag"
            [form]="form"
            label="service.settings.anamnesis.showHbsag"
        ></app-check-input>
        <app-check-input
            id="showHiv"
            [form]="form"
            label="service.settings.anamnesis.showHiv"
        ></app-check-input>
        <app-check-input
            id="showRw"
            [form]="form"
            label="service.settings.anamnesis.showRw"
        ></app-check-input>
    </ng-template>
    <ng-template #footer>
        <app-action-buttons
            (primaryClickEvent)="save()"
            (secondaryClickEvent)="cancel()"
        ></app-action-buttons>
    </ng-template>
</app-service-settings-common>
